// services/config.js
import axiosInstance from './axiosInstance';

const CONFIG_API_URL = '/config';

const configService = {
  // Obter configuração geral
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${CONFIG_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter configuração:', error);
      throw error;
    }
  },

  // Obter configuração de moeda
  async getCurrency(idempresa) {
    try {
      const response = await axiosInstance.get(`${CONFIG_API_URL}/currency/get.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data[0]?.currency || '' : '';
    } catch (error) {
      console.error('Erro ao obter configuração de moeda:', error);
      throw error;
    }
  },

  // Definir configuração de moeda
  async setCurrency(currencyData) {
    try {
      const response = await axiosInstance.post(`${CONFIG_API_URL}/currency/set.php`, currencyData);
      return response.data;
    } catch (error) {
      console.error('Erro ao definir configuração de moeda:', error);
      throw error;
    }
  },

  // Obter métodos de pagamento
  async getPaymentMethods(idempresa) {
    try {
      const response = await axiosInstance.get(`${CONFIG_API_URL}/payment/methods/get.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter métodos de pagamento:', error);
      throw error;
    }
  }
};

export default configService;
